var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.932,
    height: 162.804,
    viewBox: "0 0 176.932 162.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_new_ideas_jdea",
    transform: "translate(-367.033 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M642.091,101.538a47.145,47.145,0,0,1-6.239,24.354,48.667,48.667,0,0,1-4.434,6.368c-14.549,17.795-41.6,27.534-66.046,43.31-72.165,46.567-79.982-28.052-76.722-74.033a82.042,82.042,0,0,1,20.019-48.561,76.2,76.2,0,0,1,7.792-7.661A74.635,74.635,0,0,1,565.371,27.5c32.672,0,60.574,19.706,71.636,47.476a71.719,71.719,0,0,1,5.083,26.559Z",
    transform: "translate(-113.472 -27.503)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M636.393,88.423l-73.049,8.789a76.208,76.208,0,0,1,7.792-7.661Z",
    transform: "translate(-168.148 -71.737)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M850.057,383.662a48.674,48.674,0,0,1-4.434,6.368L783.05,382.5Z",
    transform: "translate(-327.678 -285.271)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M760.1,192.258,654.05,178.5l103.5,6.119A71.343,71.343,0,0,1,760.1,192.258Z",
    transform: "translate(-234.01 -137.145)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M475.857,79.173c0,.189-.005.375-.022.559a7.668,7.668,0,1,1-14.429-4.139,7.049,7.049,0,0,1,.564-.907,7.666,7.666,0,0,1,13.859,3.862C475.848,78.754,475.857,78.962,475.857,79.173Z",
    transform: "translate(-93.485 -59.452)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M486.022,97.327c0,.189-.005.375-.022.559L474.519,96.5,486,96.7C486.014,96.907,486.022,97.116,486.022,97.327Z",
    transform: "translate(-103.651 -77.606)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M476.211,113.615l-10.621,1.279a7.682,7.682,0,0,1-.811-1.082Z",
    transform: "translate(-96.579 -90.029)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M472.458,82.615l-8.7,1.046a7.05,7.05,0,0,1,.564-.907Z",
    transform: "translate(-95.838 -67.52)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M861.959,573.771c-.089.167-.181.329-.281.483a7.668,7.668,0,1,1-10.8-10.419,7.05,7.05,0,0,1,.923-.536,7.666,7.666,0,0,1,10.432,9.908C862.148,573.4,862.058,573.584,861.959,573.771Z",
    transform: "translate(-374.487 -415.974)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M874.334,587.41c-.089.167-.181.329-.281.483l-9.495-6.6,10.044,5.554C874.523,587.036,874.433,587.224,874.334,587.41Z",
    transform: "translate(-386.862 -429.614)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M857.788,597.66l-9.982-3.849a7.677,7.677,0,0,1-.209-1.336Z",
    transform: "translate(-374.546 -437.734)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M867.948,569.085l-8.174-3.154a7.06,7.06,0,0,1,.923-.536Z",
    transform: "translate(-383.388 -418.071)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1063.677,114.82c.132.135.258.272.374.415a7.668,7.668,0,1,1-13.219,7.111,7.065,7.065,0,0,1-.229-1.043,7.666,7.666,0,0,1,12.618-6.912C1063.379,114.525,1063.532,114.669,1063.677,114.82Z",
    transform: "translate(-521.89 -89.224)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1075.206,119.821c.132.135.258.272.374.415l-9.183,7.028,8.353-7.871C1074.908,119.526,1075.061,119.67,1075.206,119.821Z",
    transform: "translate(-533.419 -94.225)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1079.927,138.039l-6.711,8.332a7.686,7.686,0,0,1-1.336-.208Z",
    transform: "translate(-537.401 -107.764)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1056.56,123.526l-5.5,6.823a7.05,7.05,0,0,1-.229-1.043Z",
    transform: "translate(-522.118 -97.226)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M545.081,256.654l-.127-.017.31,1.18a30.989,30.989,0,0,0,1.274,4.842l9.1,34.595a5.863,5.863,0,0,0,4.774,4.3l18.559,2.871a5.863,5.863,0,0,0,6.066-3.027l17.637-32.943a30.955,30.955,0,0,0,1.509-2.818l.6-1.118-.093-.012a31.182,31.182,0,1,0-59.607-7.855Z",
    transform: "translate(-154.671 -168.137)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M575.821,300.99a6.379,6.379,0,0,1-.976-.075l-19.4-3a6.4,6.4,0,0,1-5.213-4.7l-9.512-36.161a32.606,32.606,0,0,1-1.336-5.082l-.241-1.582a32.874,32.874,0,0,1,37.63-36.664l-.084.541a32.338,32.338,0,0,0-36.956,36.4l.185,1.183a32.383,32.383,0,0,0,1.325,5.04l9.519,36.182a5.853,5.853,0,0,0,4.767,4.3l19.4,3a5.863,5.863,0,0,0,6.057-3.023l.483.258A6.415,6.415,0,0,1,575.821,300.99Z",
    transform: "translate(-150.381 -162.44)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 34.322,
    height: 0.708,
    transform: "translate(418.557 128.61) rotate(-69.885)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 0.708,
    height: 34.322,
    transform: "translate(410.381 93.428) rotate(-2.516)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M600.284,579.284l-24.858-3.846a.709.709,0,0,1,.217-1.4l24.857,3.846a.709.709,0,1,1-.217,1.4Z",
    transform: "translate(-176.485 -424.341)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M602.611,560.01l-24.858-3.846a.709.709,0,1,1,.217-1.4l24.858,3.846a.709.709,0,0,1-.217,1.4Z",
    transform: "translate(-178.174 -410.346)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M604.938,540.738l-24.858-3.846a.709.709,0,1,1,.217-1.4l24.858,3.846a.709.709,0,0,1-.217,1.4Z",
    transform: "translate(-179.864 -396.352)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M598.289,584.5c4.931.763,9.353-1.367,9.877-4.757l-17.855-2.762C589.786,580.366,593.358,583.733,598.289,584.5Z",
    transform: "translate(-187.691 -426.48)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M624.861,341.881a4.365,4.365,0,0,1-2.419-1.564c-.158-.184-.311-.375-.465-.567a5.533,5.533,0,0,0-1.826-1.7c-1.626-.759-3.542.3-5.2,1.438l-.4-.584c1.824-1.25,3.951-2.405,5.9-1.5a6.138,6.138,0,0,1,2.079,1.9c.149.186.3.371.451.55.5.584,1.5,1.531,2.567,1.312a3.45,3.45,0,0,0,1.231-.652,6.6,6.6,0,0,1,.871-.55,3.47,3.47,0,0,1,3.809.538,6.844,6.844,0,0,1,.517.547,1.763,1.763,0,0,0,2.851.335,3.664,3.664,0,0,1,2.145-.642l.076.01c1.4.216,2.039,1.759,2.4,2.911l-.676.213c-.495-1.566-1.1-2.344-1.887-2.431a3.115,3.115,0,0,0-1.725.562,2.418,2.418,0,0,1-3.72-.491,6.222,6.222,0,0,0-.462-.491,2.784,2.784,0,0,0-3.016-.426,5.983,5.983,0,0,0-.777.493,4.024,4.024,0,0,1-1.5.768A2.327,2.327,0,0,1,624.861,341.881Z",
    transform: "translate(-205.328 -252.291)",
    fill: "#d0cde1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.8fc06781943d1c0b030f9516d38363d2.svg";
export { ForwardRef as ReactComponent };